// global.$ = global.jQuery = require('jquery');
import { createApp } from 'vue'
import mitt from 'mitt'
import BoardView from '@vueapp/views/Board.vue'

export class Board {

    constructor( elements ) {

        let _this = this

        if ( elements.length ) {
            elements.forEach(function (item, key) {
                const emitter = mitt()
                const app = createApp(BoardView, {
                    postId: item.getAttribute('data-post-id'),
                    postSlug: item.getAttribute('data-post-slug'),
                    isViewWrapper: item.getAttribute('data-is-viewwrapper')
                })
                app.config.globalProperties.emitter = emitter
                app.mount('#' + item.getAttribute('id') )
            })
        }
    }
}